var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Notification } from '../../twig/components/Notification';
export class Validation extends Component {
    constructor(isDebugEnabled = false) {
        super('Validation', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('header').hasClass('header-member-area')) {
                $('input[name="mise en scène"], input[name="choregraphie"]').on('keyup', (event, input) => {
                    if ($('input[name="mise en scène"]').val().length > 0 || $('input[name="choregraphie"]').val().length > 0)
                        $('input[name="mise en scène"], input[name="choregraphie"]').removeClass('is-invalid');
                });
                $('.needs-validation').each((form) => {
                    // Disable tab navigation when editing a show
                    if (form.hasClass('form-main') && $('body').hasClass('page-template-templatesclientshow-php')) {
                        $('.nav-tabs .nav-link').on('click', (event, tab) => {
                            const formValidity = Validation.checkFormValidity(form, true);
                            if (!formValidity.isValid) {
                                event.preventDefault();
                                event.stopPropagation();
                                Notification.show(formValidity.notificationText, 'danger');
                                setTimeout(() => {
                                    alert('Impossible de changer d\'onglet tant que le formulaire n\'est pas validé et sauvegardé.');
                                }, 100);
                            }
                        });
                    }
                    form.find('input, select, textarea').on('change', (event, formElement) => {
                        formElement.removeClass('is-invalid');
                        if (!formElement.get(0).checkValidity())
                            formElement.addClass('is-invalid');
                    });
                    form.on('submit', (event) => {
                        const formValidity = Validation.checkFormValidity(form);
                        if (formValidity.isValid) {
                            $(event.submitter).addClass('is-loading');
                        }
                        else {
                            event.preventDefault();
                            event.stopPropagation();
                            form.addClass('was-validated');
                            if (!form.hasClass('form-secondary')) {
                                Notification.show(formValidity.notificationText, 'danger');
                                const scrollToY = form.hasClass('scroll-top') ? 0 : form.position().y - $('header').height();
                                $.scrollTo(scrollToY, 500);
                            }
                        }
                    }, false);
                });
            }
            this.success();
        });
    }
    static checkFormValidity(form, highlightInvalidFields = false) {
        let isFormValid = true;
        let notificationText = '';
        if (!form.get(0).checkValidity()) {
            isFormValid = false;
            form.find('.form-control').removeClass('is-invalid');
            // Check field emptiness
            let failedFieldsString = '';
            form.find('.form-control:invalid').each((field) => {
                const label = $('label[for="' + field.attr('id') + '"]');
                if (label.length > 0)
                    failedFieldsString += '<li>' + label.text().replace(' *', '') + '</li>';
                if (highlightInvalidFields && !field.get(0).checkValidity())
                    field.addClass('is-invalid');
            });
            if (failedFieldsString.length > 0)
                notificationText = '<p class="m-0">Veuillez renseigner les champs obligatoires suivants:</p><ul class="m-0">' + failedFieldsString + '</ul>';
        }
        // Check list emptiness
        let emptyListsString = '';
        $('.related-set-list').each((list) => {
            if (list.find('.related-set-list-item').length === 0)
                emptyListsString += '<li>' + list.data('title') + '</li>';
        });
        if (emptyListsString.length > 0) {
            isFormValid = false;
            notificationText += '<p class="m-0">Veuillez compléter les listes suivantes:</p><ul class="m-0">' + emptyListsString + '</ul>';
        }
        // Check uploader emptiness
        let emptyUploadersString = '';
        $('.file-uploader').each((fileUploader) => {
            fileUploader.find('input[type="file"]').removeClass('is-invalid');
            if (fileUploader.data('isRequired') !== undefined && parseInt(fileUploader.data('fileCount')) == 0) {
                emptyUploadersString += '<li>' + fileUploader.data('title') + '</li>';
                fileUploader.find('input[type="file"]').addClass('is-invalid');
            }
        });
        if (emptyUploadersString.length > 0) {
            isFormValid = false;
            notificationText += '<p class="m-0">Veuillez compléter les fichiers suivants:</p><ul class="m-0">' + emptyUploadersString + '</ul>';
        }
        // Check mise en scène & chorégraphie
        if ($('input[name="mise en scène"]').length > 0) {
            if ($('input[name="mise en scène"]').val().length === 0 && $('input[name="choregraphie"]').val().length === 0) {
                isFormValid = false;
                notificationText += '<p class="m-0">Veuillez compléter la mise en scène ou la chorégraphie.</p>';
                $('input[name="mise en scène"], input[name="choregraphie"]').addClass('is-invalid');
            }
        }
        // Check genre
        if ($('.list-genre').length > 0 && $('.list-genre input:checked').length < 3) {
            isFormValid = false;
            notificationText += '<p class="m-0">Veuillez cocher au moins trois genres.</p>';
        }
        // Support check tour selected
        $('.tours-selector').each((element) => {
            element.find('label').removeClass('text-danger');
            if (element.find('input:checked').length === 0) {
                element.find('label').addClass('text-danger');
                isFormValid = false;
                notificationText += '<p class="m-0">Veuillez sélectionner au moins une date par spectacle.</p>';
            }
        });
        // Support check destination
        $('.support_destination').each((element) => {
            element.find('input[type="checkbox"] + label').removeClass('text-danger');
            const checkedDestinationsCount = element.find('input:checked').length;
            const isOtherOk = element.find('input[type="text"]').length > 0 && element.find('input[type="text"]').val().length == 0 ? false : true;
            if (checkedDestinationsCount === 0 && !isOtherOk) {
                element.find('input[type="checkbox"] + label').addClass('text-danger');
                isFormValid = false;
                notificationText += '<p class="m-0">Veuillez préciser la destination du soutien demandé.</p>';
            }
        });
        // Field other
        $('.form-field-other').each((field) => {
            const checkbox = field.find('input[type="checkbox"]');
            const text = field.find('input[type="text"]');
            text.removeClass('is-invalid');
            if (text.val() == '' && checkbox.get(0).checked) {
                isFormValid = false;
                text.addClass('is-invalid');
                notificationText += '<p class="m-0">Veuillez remplire le champs «autre».</p>';
            }
        });
        // Check languages
        if ($('.language-selector').length > 0) {
            let checkedLanguagesCount = 0;
            $('#lang_spe_line input[type="checkbox"]').each((checkbox) => {
                if (checkbox.get(0).checked)
                    checkedLanguagesCount++;
            });
            if (checkedLanguagesCount === 0) {
                isFormValid = false;
                notificationText += '<p class="m-0">Veuillez sélectionner au moins une langue.</p>';
            }
        }
        if (!isFormValid)
            $('.btn-loading').removeClass('is-loading');
        return { isValid: isFormValid, notificationText: notificationText };
    }
}
